import React, { useContext } from "react";
import { userContext } from "../Context/userContext";

const BillingErr = () => {
  const { Msisdn } = useContext(userContext);
  return (
    <div className="container-fluid lynx-background Lynx_docs">
      <div className="container">
        <div className="lynx_darkcards_noborder mx-auto" style={{ maxWidth: "560px" }}>
          <div className="p-4 text-center lynx_opacity_text">
            <h1 className="text-lynx">⏳ Welcome to Lynx LifeStyle!</h1>
            <p>
              Unfortunately your daily subscription has not been received
              recently. Please make sure you have airtime on your Cellphone
              number {Msisdn}
            </p>
            <p>
              Want <strong>UNLIMITED</strong> content and a chance to{" "}
              <strong>WIN DAILY AIRTIME</strong>?{" "}
            </p>
            <p className="mb-0">
              Don't have an account? SMS lynx to 33270 (std sms rates, R2 per
              day, T&Cs apply)
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillingErr;
